<template>
  <el-dialog
    v-if="dialogVisible"
    class="cross-record-result-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="20vh"
  >
    <el-descriptions class="margin-top" title="源" :column="1" :border="true">
      <el-descriptions-item>
        <template slot="label">
          链ID
        </template>
        {{ paramsData.tx_responses[0].chain_id }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          区块高度
        </template>
        {{ paramsData.tx_responses[0].block_height }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          交易key
        </template>
        {{ paramsData.tx_responses[0].tx_key }}
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions class="margin-top" title="目的" :column="1" :border="true">
      <el-descriptions-item>
        <template slot="label">
          链ID
        </template>
        {{ paramsData.tx_responses[1].chain_id }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          区块高度
        </template>
        {{ paramsData.tx_responses[1].block_height }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          交易key
        </template>
        {{ paramsData.tx_responses[1].tx_key }}
      </el-descriptions-item>
    </el-descriptions>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CrossDetailsResult',
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      paramsData: {},
      title: '详细结果'
    }
  },
  mounted() {},
  methods: {
    handleCancel() {
      this.dialogVisible = false
      this.disabled = false
    },
    handleOpen(data) {
      if (data.data) {
        this.paramsData = JSON.parse(data.data)
      }
      console.log(this.paramsData)
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.cross-record-result-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .el-descriptions {
    margin-bottom: var(--base-size-24);
  }
}
</style>
